import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { MobileNavItems } from "@/components/MobileNavItems";
import { MobileMetalPuritySelector } from "@/components/MobileMetalPuritySelector";
import { useAuth } from "@/hooks/useAuth";
import { useHydrationSafe } from "@/hooks/useHydrationSafe";

export function MobileMenu() {
  const { isAuthenticated, role } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isHydrated } = useHydrationSafe();

  const closeMenu = () => setIsMenuOpen(false);

  // 🛡️ Pre-hydration: render static hamburger button only
  // This prevents Sheet/Portal and NavLink from causing hydration mismatch (#418)
  // The button won't open the menu until hydration completes (acceptable trade-off)
  if (!isHydrated) {
    return (
      <Button variant="outline" size="icon" aria-label="Apri menu navigazione">
        <Menu className="h-5 w-5" />
      </Button>
    );
  }

  // Post-hydration: full interactive Sheet with MobileNavItems
  return (
    <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
      <SheetTrigger asChild>
        <Button variant="outline" size="icon" aria-label="Apri menu navigazione">
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="right">
        <div className="flex flex-col space-y-4 py-4">
          <MobileNavItems
            isAuthenticated={isAuthenticated}
            userRole={role}
            onItemClick={closeMenu}
          />

          <MobileMetalPuritySelector />
        </div>
      </SheetContent>
    </Sheet>
  );
}
